import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import config from 'utils/config';
import checkIsEditableAsset from 'utils/checkIsEditableAsset';
import { canUserShare, hasMyTeamsAccess } from 'utils/privileges';
import { useAssetViewerContext } from 'screens/AssetViewerUI/hooks/useAssetViewerContext';
import Box from 'components/Box';
import { ActionGrid, ActionGridButton } from 'screens/AssetViewerUI';
import MarkAsDone from './MarkAsDone';
import Like from './Like';
import Share from './Share';
import Save from './Save';
import Download from './Download';
import Stats from './Stats';
import Edit from './Edit';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Actions(_ref) {
  var autoCompleteEnabled = _ref.autoCompleteEnabled;
  var _useAssetViewerContex = useAssetViewerContext(),
    asset = _useAssetViewerContex.asset,
    downloadUrl = _useAssetViewerContex.downloadUrl;
  if (!asset) return null;
  var parentPlaylist = asset.parentPlaylists.find(function (playlist) {
    return playlist.id === asset.collection_id;
  });
  var showShareButton = canUserShare();
  var showDownloadButton = downloadUrl && asset.download !== 'required';
  var showStatsButton = config.managerReports && asset.insightsEnabled && hasMyTeamsAccess();
  var showEditButton = checkIsEditableAsset({
    contentItem: asset,
    allowEditingDistributedAssets: true
  });
  return /*#__PURE__*/_jsx(Box, {
    p: "xxs",
    children: /*#__PURE__*/_jsxs(ActionGrid, {
      children: [!autoCompleteEnabled && /*#__PURE__*/_jsx(MarkAsDone, {
        as: ActionGridButton
      }), /*#__PURE__*/_jsx(Like, {
        as: ActionGridButton
      }), showShareButton && /*#__PURE__*/_jsx(Share, {
        as: ActionGridButton
      }), /*#__PURE__*/_jsx(Save, {
        as: ActionGridButton
      }), showDownloadButton && /*#__PURE__*/_jsx(Download, {
        as: ActionGridButton
      }), showStatsButton && /*#__PURE__*/_jsx(Stats, {
        as: ActionGridButton
      }), showEditButton && /*#__PURE__*/_jsx(Edit, {
        as: ActionGridButton,
        parentPlaylistId: asset.collection_id,
        parentPlaylist: parentPlaylist,
        asset: asset
      })]
    })
  });
}
export default Actions;